import MultipleDepartmentJobBrowser from "./MultipleDepartmentJobBrowser";
import SingleDepartmentJobBrowser from "./SingleDepartmentJobBrowser";

export { MultipleDepartmentJobBrowser, SingleDepartmentJobBrowser };
